import { call, put, all, takeEvery } from "redux-saga/effects";

import {
  PURCHASE_ORDER_LIST_GET_REQUEST,
  PURCHASE_ORDER_SEARCH_REQUEST,
  PURCHASE_ORDER_DATA_REQUEST,
  PURCHASE_ORDER_CREATE_REQUEST,
  PURCHASE_ORDER_UPDATE_REQUEST,
  PURCHASE_ORDER_VOID_REQUEST,
  PURCHASE_ORDER_MARK_COMPLETE_REQUEST,
  PURCHASE_ORDER_STATUS_LIST_GET_REQUEST,
  PURCHASE_ORDER_STATUS_DATA_REQUEST,
  PURCHASE_ORDER_STATUS_CREATE_REQUEST,
  PURCHASE_ORDER_STATUS_UPDATE_REQUEST,
  PURCHASE_ORDER_STATUS_DELETE_REQUEST,
  PURCHASE_ORDER_PDF_REQUEST,
} from "./actionType";

import {
  purchaseOrderListGetSuccess,
  purchaseOrderListGetFailure,
  purchaseOrderSearchSuccess,
  purchaseOrderSearchFailure,
  purchaseOrderDataSuccess,
  purchaseOrderDataFailure,
  purchaseOrderCreateSuccess,
  purchaseOrderCreateFailure,
  purchaseOrderUpdateSuccess,
  purchaseOrderUpdateFailure,
  purchaseOrderVoidSuccess,
  purchaseOrderVoidFailure,
  purchaseOrderMarkCompleteSuccess,
  purchaseOrderMarkCompleteFailure,
  purchaseOrderStatusListGetSuccess,
  purchaseOrderStatusListGetFailure,
  purchaseOrderStatusDataSuccess,
  purchaseOrderStatusDataFailure,
  purchaseOrderStatusCreateSuccess,
  purchaseOrderStatusCreateFailure,
  purchaseOrderStatusUpdateSuccess,
  purchaseOrderStatusUpdateFailure,
  purchaseOrderStatusDeleteSuccess,
  purchaseOrderStatusDeleteFailure,
  purchaseOrderPdfSuccess,
  purchaseOrderPdfFailure,
} from "./action";

import {
  getPurchaseOrderListAPI,
  getPurchaseOrderSearchAPI,
  getPurchaseOrderDataAPI,
  createPurchaseOrderAPI,
  updatePurchaseOrderAPI,
  voidPurchaseOrderAPI,
  markCompletePurchaseOrderAPI,
  getPurchaseOrderStatusListAPI,
  getPurchaseOrderStatusDataAPI,
  createPurchaseOrderStatusAPI,
  updatePurchaseOrderStatusAPI,
  deletePurchaseOrderStatusAPI,
  getPurchaseOrderPdfAPI,
} from "../../helpers/fakebackend_helper";

//purchase order list get
function* purchaseOrderListGet() {
  try {
    const response = yield call(getPurchaseOrderListAPI);
    yield put(purchaseOrderListGetSuccess(response));
  } catch (error) {
    yield put(purchaseOrderListGetFailure(error));
  }
}
function* watchPurchaseOrderListGetRequest() {
  yield takeEvery(PURCHASE_ORDER_LIST_GET_REQUEST, purchaseOrderListGet);
}

//purchase order search
function* purchaseOrderSearch({ payload }) {
  try {
    const response = yield call(getPurchaseOrderSearchAPI, payload);
    yield put(purchaseOrderSearchSuccess(response));
  } catch (error) {
    yield put(purchaseOrderSearchFailure(error));
  }
}
function* watchPurchaseOrderSearchRequest() {
  yield takeEvery(PURCHASE_ORDER_SEARCH_REQUEST, purchaseOrderSearch);
}

//purchase order data
function* purchaseOrderData({ payload }) {
  try {
    const response = yield call(getPurchaseOrderDataAPI, payload);
    yield put(purchaseOrderDataSuccess(response));
  } catch (error) {
    yield put(purchaseOrderDataFailure(error));
  }
}
function* watchPurchaseOrderDataRequest() {
  yield takeEvery(PURCHASE_ORDER_DATA_REQUEST, purchaseOrderData);
}

//purchase order create
function* purchaseOrderCreate({ payload }) {
  try {
    const response = yield call(createPurchaseOrderAPI, payload);
    yield put(purchaseOrderCreateSuccess(response));
  } catch (error) {
    yield put(purchaseOrderCreateFailure(error));
  }
}
function* watchPurchaseOrderCreateRequest() {
  yield takeEvery(PURCHASE_ORDER_CREATE_REQUEST, purchaseOrderCreate);
}

//purchase order update
function* purchaseOrderUpdate({ payload }) {
  try {
    const response = yield call(updatePurchaseOrderAPI, payload);
    yield put(purchaseOrderUpdateSuccess(response));
  } catch (error) {
    yield put(purchaseOrderUpdateFailure(error));
  }
}
function* watchPurchaseOrderUpdateRequest() {
  yield takeEvery(PURCHASE_ORDER_UPDATE_REQUEST, purchaseOrderUpdate);
}

//purchase order void
function* purchaseOrderVoid({ payload }) {
  try {
    const response = yield call(voidPurchaseOrderAPI, payload);
    yield put(purchaseOrderVoidSuccess(response));
  } catch (error) {
    yield put(purchaseOrderVoidFailure(error));
  }
}
function* watchPurchaseOrderVoidRequest() {
  yield takeEvery(PURCHASE_ORDER_VOID_REQUEST, purchaseOrderVoid);
}

//purchase order mark complete
function* purchaseOrderMarkComplete({ payload }) {
  try {
    const response = yield call(markCompletePurchaseOrderAPI, payload);
    yield put(purchaseOrderMarkCompleteSuccess(response));
  } catch (error) {
    yield put(purchaseOrderMarkCompleteFailure(error));
  }
}
function* watchPurchaseOrderMarkCompleteRequest() {
  yield takeEvery(
    PURCHASE_ORDER_MARK_COMPLETE_REQUEST,
    purchaseOrderMarkComplete
  );
}

//purchase order status list get
function* purchaseOrderStatusListGet() {
  try {
    const response = yield call(getPurchaseOrderStatusListAPI);
    yield put(purchaseOrderStatusListGetSuccess(response));
  } catch (error) {
    yield put(purchaseOrderStatusListGetFailure(error));
  }
}
function* watchPurchaseOrderStatusListGetRequest() {
  yield takeEvery(
    PURCHASE_ORDER_STATUS_LIST_GET_REQUEST,
    purchaseOrderStatusListGet
  );
}

//purchase order status data
function* purchaseOrderStatusData({ payload }) {
  try {
    const response = yield call(getPurchaseOrderStatusDataAPI, payload);
    yield put(purchaseOrderStatusDataSuccess(response));
  } catch (error) {
    yield put(purchaseOrderStatusDataFailure(error));
  }
}
function* watchPurchaseOrderStatusDataRequest() {
  yield takeEvery(PURCHASE_ORDER_STATUS_DATA_REQUEST, purchaseOrderStatusData);
}

//purchase order status create
function* purchaseOrderStatusCreate({ payload }) {
  try {
    const response = yield call(createPurchaseOrderStatusAPI, payload);
    yield put(purchaseOrderStatusCreateSuccess(response));
  } catch (error) {
    yield put(purchaseOrderStatusCreateFailure(error));
  }
}
function* watchPurchaseOrderStatusCreateRequest() {
  yield takeEvery(
    PURCHASE_ORDER_STATUS_CREATE_REQUEST,
    purchaseOrderStatusCreate
  );
}

//purchase order status update
function* purchaseOrderStatusUpdate({ payload }) {
  try {
    const response = yield call(updatePurchaseOrderStatusAPI, payload);
    yield put(purchaseOrderStatusUpdateSuccess(response));
  } catch (error) {
    yield put(purchaseOrderStatusUpdateFailure(error));
  }
}
function* watchPurchaseOrderStatusUpdateRequest() {
  yield takeEvery(
    PURCHASE_ORDER_STATUS_UPDATE_REQUEST,
    purchaseOrderStatusUpdate
  );
}

//purchase order status delete
function* purchaseOrderStatusDelete({ payload }) {
  try {
    const response = yield call(deletePurchaseOrderStatusAPI, payload);
    yield put(purchaseOrderStatusDeleteSuccess(response));
  } catch (error) {
    yield put(purchaseOrderStatusDeleteFailure(error));
  }
}
function* watchPurchaseOrderStatusDeleteRequest() {
  yield takeEvery(
    PURCHASE_ORDER_STATUS_DELETE_REQUEST,
    purchaseOrderStatusDelete
  );
}

//purchase order pdf
function* purchaseOrderPdf({ payload }) {
  try {
    const response = yield call(getPurchaseOrderPdfAPI, payload);
    yield put(purchaseOrderPdfSuccess(response));
  } catch (error) {
    yield put(purchaseOrderPdfFailure(error));
  }
}
function* watchPurchaseOrderPdfRequest() {
  yield takeEvery(PURCHASE_ORDER_PDF_REQUEST, purchaseOrderPdf);
}

export default function* PurchaseOrder() {
  yield all([
    watchPurchaseOrderListGetRequest(),
    watchPurchaseOrderSearchRequest(),
    watchPurchaseOrderDataRequest(),
    watchPurchaseOrderCreateRequest(),
    watchPurchaseOrderUpdateRequest(),
    watchPurchaseOrderVoidRequest(),
    watchPurchaseOrderMarkCompleteRequest(),
    watchPurchaseOrderStatusListGetRequest(),
    watchPurchaseOrderStatusDataRequest(),
    watchPurchaseOrderStatusCreateRequest(),
    watchPurchaseOrderStatusUpdateRequest(),
    watchPurchaseOrderStatusDeleteRequest(),
    watchPurchaseOrderPdfRequest(),
  ]);
}
